import { TypeLieu } from './type-lieu';

export class Lieu {
  constructor(
    public readonly id: number | undefined,
    public readonly nom: string,
    public readonly adresse?: string,
    public readonly description?: string,
    public readonly type?: TypeLieu,
    public readonly nombreMaxParticipants?: number,
  ) {}
}
